
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34608',
  depVersions: {
  "documents-public-ui": "static-1.34608",
  "atom": "static-1.5106",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2531",
  "client-types": "static-1.469",
  "cssUtils": "static-1.798",
  "customer-data-filters-ui": "static-1.39932",
  "customer-data-objects": "static-1.7706",
  "customer-data-property-utils": "static-1.8124",
  "documents-lib": "static-1.34613",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.341",
  "FormsCommonComponents": "static-1.85958",
  "FormUrlGenerator": "static-2.4751",
  "foundations-theming-specialty": "static-1.2168",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5623",
  "hs-test-utils": "static-1.8047",
  "hub-http": "static-1.6255",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11812",
  "HubStyleTokens": "static-2.11505",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3053",
  "jasmine-runner": "static-1.6496",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7188",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5431",
  "quartz": "static-1.7071",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16706",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5369",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8204",
  "reference-resolvers-lite": "static-1.8128",
  "reporting-data": "static-1.67712",
  "reporting-reports": "static-1.67390",
  "reporting-snowflake": "static-1.56330",
  "reporting-testing-lib": "static-1.9645",
  "reporting-visualizations": "static-1.59788",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8975",
  "sanitize": "static-1.4508",
  "sanitize-text": "static-1.8175",
  "self-service-api": "static-1.10280",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1780",
  "signup-constants": "static-1.18900",
  "signup-ui-url-generator": "static-2.8086",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4793",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4795",
  "ui-addon-form-validation": "static-1.11022",
  "ui-asset-management-lib": "static-1.11082",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8451",
  "usage-tracker": "static-1.7380",
  "usage-tracker-container": "static-1.7370",
  "usage-tracker-core": "static-1.7230",
  "viral-links-lib": "static-1.7100",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9699",
  "foundations-components": "static-1.7998",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.849",
  "quartz-core": "static-1.6290",
  "quick-fetch": "static-1.3941",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4685",
  "ui-addon-i18n": "static-1.11181",
  "ui-addon-upgrades": "static-9.18046",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3424",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3348",
  "quartz-webpack": "static-1.3295",
  "foundations-assets": "static-1.4901",
  "foundations-theming": "static-1.4452",
  "hub-http-shared-msw-handlers": "static-1.10050",
  "hubspotter-http": "static-1.4676",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.258",
  "conversations-skeleton-state": "static-1.7280",
  "crm-message-bus": "static-1.43071",
  "customer-data-filters-ui-msw-helpers": "static-1.22367",
  "customer-data-objects-ui-components": "static-1.13062",
  "customer-data-reference-ui-components": "static-1.13199",
  "customer-data-ui-utilities": "static-1.9858",
  "framework-builder-read-service-client": "static-1.4030",
  "framework-data-schema-quick-fetch": "static-1.6823",
  "framework-data-schema-resolvers": "static-1.6918",
  "inbound-db-meta-service-client": "static-1.3611",
  "inbound-db-properties-service-client": "static-1.3871",
  "multi-account-reference-resolvers": "static-1.1013",
  "onboarding-tours": "static-1.16672",
  "reporting-datasets-permissions-lib": "static-1.13789",
  "ui-addon-teams": "static-1.21603",
  "quartz-auth": "static-1.746",
  "ui-business-units-lib": "static-1.9089",
  "usage-tracker-session-replay": "static-1.5066",
  "ai-components-ui-library": "static-1.9061",
  "ContentUtils": "static-1.68477",
  "customer-data-properties": "static-1.51697",
  "forms-ai-lib": "static-1.4366",
  "forms-utils-lib": "static-1.12646",
  "foundations-components-test-utils": "static-1.5481",
  "react-dnd-compat": "static-1.4647",
  "react-tinymce": "static-1.55352",
  "tinymce-config": "static-2.54478",
  "ui-gdpr-components": "static-1.10383",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3437",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3158",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.106",
  "ui-fonts": "static-1.767",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4359",
  "csstype": "static-1.50",
  "quartz-head": "static-1.736",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1574",
  "external-options-client-types": "static-1.4184",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.746",
  "frontend-preferences-client": "static-1.7960",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3731",
  "reporting-client-types": "static-1.2508",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25489",
  "hubspot-apollo-client": "static-1.4911",
  "foundations-components-legacy": "static-1.1023",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.501",
  "hs-story-utils": "static-1.9456",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.259",
  "timezone-utils": "static-2.5277",
  "seat-types-lib": "static-1.96",
  "bend-plugin-foundations-components": "static-1.4267",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2038",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.746",
  "quartz-tracking": "static-1.450",
  "bend-plugin-chirp-manifest": "static-1.95",
  "chirp-fetch": "static-1.1920",
  "purchase-motions-components": "static-1.5979",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4105",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-foundations-theming": "static-1.2935",
  "stylex": "static-1.33",
  "hs-resources": "static-1.189",
  "pulse": "static-1.612",
  "restore-request-side-panel-lib": "static-1.997",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3822",
  "crm-pipelines-api-client-types": "static-1.4164",
  "fdsr-migration-layer": "static-1.37",
  "multi-currency-client-types": "static-1.3716",
  "getting-started-shared-tasks": "static-1.18550",
  "growth-data-modal": "static-1.5477",
  "growth-onboarding-confetti": "static-1.3099",
  "growth-onboarding-next-action-utils": "static-1.2031",
  "navigation-components": "static-1.18130",
  "onboarding-tours-client": "static-1.4886",
  "onboarding-tours-utils": "static-1.738",
  "ui-shepherd-react": "static-3.10205",
  "ui-shepherd-tracker": "static-1.7586",
  "ui-universal-auth": "static-1.9016",
  "user-context": "static-1.5138",
  "hubspotter-http-shared-msw-handlers": "static-1.10048",
  "magpie-lib": "static-1.5572",
  "navigation-messaging": "static-1.7457",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21444",
  "copilot-toolkit": "static-1.11224",
  "cms-field-types": "static-1.4845",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16288",
  "calling-global-api": "static-1.64637",
  "calling-internal-common": "static-1.31335",
  "calling-lifecycle-internal": "static-1.66019",
  "calling-lifecycle-messages": "static-1.58313",
  "commerce-products-lib": "static-1.9702",
  "crm-links": "static-1.6333",
  "customer-data-properties-shared-msw-handlers": "static-1.9377",
  "file-manager-components": "static-1.23719",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4248",
  "meetings-icalendar-utils-lib": "static-1.664",
  "object-builder-ui-client": "static-1.48875",
  "pipeline-validation-client-types": "static-1.3990",
  "property-value-citations": "static-1.2311",
  "smart-property-lib": "static-1.7275",
  "tiered-pricing": "static-1.1296",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9093",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19888",
  "tinymce-themes": "static-1.56448",
  "data-token-picker": "static-1.16462",
  "hub-http-contrib": "static-1.3074",
  "interframe": "static-3.4792",
  "tinymce-data": "static-1.40563",
  "tinymce-plugins": "static-1.57592",
  "ui-addon-sales-email": "static-1.5243",
  "onboarding-scopes": "static-1.6493",
  "ui-addon-opt": "static-4.8395",
  "apollo-link-hub-http": "static-2.4684",
  "hubspot-apollo-cache": "static-1.370",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.204",
  "purchase-motions-api": "static-1.5982",
  "bend-plugin-pulse": "static-1.115",
  "event-emitter": "static-1.980",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.2006",
  "growth-onboarding-next-action-components": "static-1.2059",
  "user-context-client": "static-1.4644",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5032",
  "nest": "static-1.262",
  "reactive-lib": "static-1.755",
  "simple-logging-lib": "static-1.3083",
  "unified-auth-core-lib": "static-1.812",
  "getting-started-shared-tasks-store": "static-1.17668",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13703",
  "integrations-tracking-lib": "static-1.5635",
  "native-integrations-shared-strings": "static-1.7814",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10398",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.530",
  "calling-error-reporting": "static-1.31342",
  "shared-worker-versioning": "static-1.11069",
  "calling-usage-tracker": "static-1.6573",
  "voice-sms-access-library": "static-1.1149",
  "customer-data-tracking": "static-1.6922",
  "commerce-permissions": "static-1.805",
  "products-iframe-lib": "static-1.8041",
  "products-ui-components-shared-msw-handlers": "static-1.10432",
  "location-customization-utils-lib": "static-1.9375",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4186",
  "video-components-external": "static-1.11415",
  "video-data-lib": "static-1.35073",
  "data-agent-kit": "static-1.244",
  "feedback-loader": "static-1.29358",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10133",
  "fsm": "static-1.3764",
  "policy-lib": "static-1.6809",
  "react-colorpicker": "static-2.10240",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10196",
  "FileManagerLib": "static-1.39359",
  "NamespacedHubStyle": "static-2.9083",
  "FileManagerCore": "static-1.39218",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7800",
  "layout-dnd-components": "static-1.12505",
  "layout-dnd-utils": "static-1.11480",
  "react-codemirror": "static-1.10658",
  "ui-addon-emoji-picker": "static-1.9920",
  "ui-brand-identity-lib": "static-1.15435",
  "InboxConnectUtils": "static-4.14919",
  "meetings-connect-utils-lib": "static-1.7637",
  "universal-page-editor-lib": "static-1.3046",
  "google-sheets-integration-lib": "static-1.351",
  "microsoft-drive-integration-lib": "static-1.477",
  "slack-ui-library": "static-1.10425",
  "calling-orchestration-schema": "static-1.35926",
  "sales-views-client-types": "static-1.4292",
  "crm-record-cards-service-types": "static-1.3615",
  "content-media-composition-data-lib": "static-1.12456",
  "content-media-compositions": "static-2.16463",
  "media-bridge-lib": "static-1.18981",
  "trellis-story-utils": "static-1.4547",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5963",
  "FileManagerImages": "static-1.36870",
  "video-components": "static-1.13418",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4569",
  "video-embed": "static-1.35907",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8735",
  "ui-coaching-tips": "static-1.28668",
  "ContentData": "static-1.68552",
  "layout-data-lib": "static-1.9805",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22215",
  "outpost": "static-1.4211",
  "growth-onboarding-feedback-components": "static-1.6612",
  "advanced-menus-core": "static-1.15177",
  "advanced-menus-lib": "static-1.12115",
  "ExportDialog": "static-6.10417",
  "ui-memberships-settings-lib": "static-1.34153",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15176",
  "simple-menus-lib": "static-1.16693"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34608",
  "atom": "/atom/static-1.5106",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2531",
  "client-types": "/client-types/static-1.469",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39932",
  "customer-data-objects": "/customer-data-objects/static-1.7706",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8124",
  "documents-lib": "/documents-lib/static-1.34613",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.341",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85958",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4751",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2168",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5623",
  "hs-test-utils": "/hs-test-utils/static-1.8047",
  "hub-http": "/hub-http/static-1.6255",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11812",
  "HubStyleTokens": "/HubStyleTokens/static-2.11505",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3053",
  "jasmine-runner": "/jasmine-runner/static-1.6496",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7188",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5431",
  "quartz": "/quartz/static-1.7071",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16706",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5369",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8204",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8128",
  "reporting-data": "/reporting-data/static-1.67712",
  "reporting-reports": "/reporting-reports/static-1.67390",
  "reporting-snowflake": "/reporting-snowflake/static-1.56330",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9645",
  "reporting-visualizations": "/reporting-visualizations/static-1.59788",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8975",
  "sanitize": "/sanitize/static-1.4508",
  "sanitize-text": "/sanitize-text/static-1.8175",
  "self-service-api": "/self-service-api/static-1.10280",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1780",
  "signup-constants": "/signup-constants/static-1.18900",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8086",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4793",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4795",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11022",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11082",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8451",
  "usage-tracker": "/usage-tracker/static-1.7380",
  "usage-tracker-container": "/usage-tracker-container/static-1.7370",
  "usage-tracker-core": "/usage-tracker-core/static-1.7230",
  "viral-links-lib": "/viral-links-lib/static-1.7100",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9699",
  "foundations-components": "/foundations-components/static-1.7998",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.849",
  "quartz-core": "/quartz-core/static-1.6290",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4685",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11181",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18046",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3424",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3348",
  "quartz-webpack": "/quartz-webpack/static-1.3295",
  "foundations-assets": "/foundations-assets/static-1.4901",
  "foundations-theming": "/foundations-theming/static-1.4452",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10050",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.258",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7280",
  "crm-message-bus": "/crm-message-bus/static-1.43071",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22367",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13062",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13199",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9858",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4030",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6823",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6918",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3611",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3871",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1013",
  "onboarding-tours": "/onboarding-tours/static-1.16672",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13789",
  "ui-addon-teams": "/ui-addon-teams/static-1.21603",
  "quartz-auth": "/quartz-auth/static-1.746",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9089",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5066",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9061",
  "ContentUtils": "/ContentUtils/static-1.68477",
  "customer-data-properties": "/customer-data-properties/static-1.51697",
  "forms-ai-lib": "/forms-ai-lib/static-1.4366",
  "forms-utils-lib": "/forms-utils-lib/static-1.12646",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5481",
  "react-dnd-compat": "/react-dnd-compat/static-1.4647",
  "react-tinymce": "/react-tinymce/static-1.55352",
  "tinymce-config": "/tinymce-config/static-2.54478",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10383",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3437",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3158",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.106",
  "ui-fonts": "/ui-fonts/static-1.767",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4359",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.736",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1574",
  "external-options-client-types": "/external-options-client-types/static-1.4184",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.746",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7960",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3731",
  "reporting-client-types": "/reporting-client-types/static-1.2508",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25489",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4911",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1023",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.501",
  "hs-story-utils": "/hs-story-utils/static-1.9456",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.259",
  "timezone-utils": "/timezone-utils/static-2.5277",
  "seat-types-lib": "/seat-types-lib/static-1.96",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4267",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2038",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.746",
  "quartz-tracking": "/quartz-tracking/static-1.450",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.95",
  "chirp-fetch": "/chirp-fetch/static-1.1920",
  "purchase-motions-components": "/purchase-motions-components/static-1.5979",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4105",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2935",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.189",
  "pulse": "/pulse/static-1.612",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.997",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3822",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4164",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.37",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3716",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18550",
  "growth-data-modal": "/growth-data-modal/static-1.5477",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3099",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2031",
  "navigation-components": "/navigation-components/static-1.18130",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4886",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.738",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10205",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7586",
  "ui-universal-auth": "/ui-universal-auth/static-1.9016",
  "user-context": "/user-context/static-1.5138",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10048",
  "magpie-lib": "/magpie-lib/static-1.5572",
  "navigation-messaging": "/navigation-messaging/static-1.7457",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21444",
  "copilot-toolkit": "/copilot-toolkit/static-1.11224",
  "cms-field-types": "/cms-field-types/static-1.4845",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16288",
  "calling-global-api": "/calling-global-api/static-1.64637",
  "calling-internal-common": "/calling-internal-common/static-1.31335",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66019",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58313",
  "commerce-products-lib": "/commerce-products-lib/static-1.9702",
  "crm-links": "/crm-links/static-1.6333",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9377",
  "file-manager-components": "/file-manager-components/static-1.23719",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4248",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.664",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48875",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3990",
  "property-value-citations": "/property-value-citations/static-1.2311",
  "smart-property-lib": "/smart-property-lib/static-1.7275",
  "tiered-pricing": "/tiered-pricing/static-1.1296",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9093",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19888",
  "tinymce-themes": "/tinymce-themes/static-1.56448",
  "data-token-picker": "/data-token-picker/static-1.16462",
  "hub-http-contrib": "/hub-http-contrib/static-1.3074",
  "interframe": "/interframe/static-3.4792",
  "tinymce-data": "/tinymce-data/static-1.40563",
  "tinymce-plugins": "/tinymce-plugins/static-1.57592",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5243",
  "onboarding-scopes": "/onboarding-scopes/static-1.6493",
  "ui-addon-opt": "/ui-addon-opt/static-4.8395",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4684",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.370",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.204",
  "purchase-motions-api": "/purchase-motions-api/static-1.5982",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.115",
  "event-emitter": "/event-emitter/static-1.980",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2006",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2059",
  "user-context-client": "/user-context-client/static-1.4644",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5032",
  "nest": "/nest/static-1.262",
  "reactive-lib": "/reactive-lib/static-1.755",
  "simple-logging-lib": "/simple-logging-lib/static-1.3083",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.812",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17668",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13703",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5635",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7814",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10398",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.530",
  "calling-error-reporting": "/calling-error-reporting/static-1.31342",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11069",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6573",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1149",
  "customer-data-tracking": "/customer-data-tracking/static-1.6922",
  "commerce-permissions": "/commerce-permissions/static-1.805",
  "products-iframe-lib": "/products-iframe-lib/static-1.8041",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9375",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4186",
  "video-components-external": "/video-components-external/static-1.11415",
  "video-data-lib": "/video-data-lib/static-1.35073",
  "data-agent-kit": "/data-agent-kit/static-1.244",
  "feedback-loader": "/feedback-loader/static-1.29358",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10133",
  "fsm": "/fsm/static-1.3764",
  "policy-lib": "/policy-lib/static-1.6809",
  "react-colorpicker": "/react-colorpicker/static-2.10240",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10196",
  "FileManagerLib": "/FileManagerLib/static-1.39359",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9083",
  "FileManagerCore": "/FileManagerCore/static-1.39218",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7800",
  "layout-dnd-components": "/layout-dnd-components/static-1.12505",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11480",
  "react-codemirror": "/react-codemirror/static-1.10658",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9920",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15435",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14919",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7637",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3046",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.351",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.477",
  "slack-ui-library": "/slack-ui-library/static-1.10425",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35926",
  "sales-views-client-types": "/sales-views-client-types/static-1.4292",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12456",
  "content-media-compositions": "/content-media-compositions/static-2.16463",
  "media-bridge-lib": "/media-bridge-lib/static-1.18981",
  "trellis-story-utils": "/trellis-story-utils/static-1.4547",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5963",
  "FileManagerImages": "/FileManagerImages/static-1.36870",
  "video-components": "/video-components/static-1.13418",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4569",
  "video-embed": "/video-embed/static-1.35907",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8735",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28668",
  "ContentData": "/ContentData/static-1.68552",
  "layout-data-lib": "/layout-data-lib/static-1.9805",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22215",
  "outpost": "/outpost/static-1.4211",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6612",
  "advanced-menus-core": "/advanced-menus-core/static-1.15177",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12115",
  "ExportDialog": "/ExportDialog/static-6.10417",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34153",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15176",
  "simple-menus-lib": "/simple-menus-lib/static-1.16693"
}
};
